/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function FileUploadModalController (
    _,
    $q,
    $window
) {

    var self = this;

    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    var getAcceptProfileData = function (acceptObject) {
        if (acceptObject.acceptProfile) {
            return acceptObject.acceptProfile;
        } else {
            return acceptObject;
        }
    };

    if (self.resolve.fileFilterType !== 'TEXT') {
        var fileExtensions = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).fileExtensions;
        });

        var acceptHeights = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).height;
        });

        var acceptWidths = self.resolve.acceptTemplateMembers.map(function (acceptTemplateMember) {
            return getAcceptProfileData(acceptTemplateMember).width;
        });
    }


    //================//
    // Template Logic //
    //================//

    self.getUploadButtonText = function () {
        var fileFilters = _.uniqBy(_.flatten(fileExtensions), _.upperCase).join('|').toUpperCase();
        var buttonText = '';
        switch (self.resolve.fileFilterType.toLowerCase()) {
            case 'image':
                buttonText = 'Select ' + self.fileWidths + ' x ' + self.fileHeights + ' ' + fileFilters + ' Image';
                break;
            default:
                buttonText = 'Select ' + self.resolve.fileFilterType.toUpperCase();
        }
        return buttonText;
    };

    self.getFileExtensions = function () {
        return _.chain(fileExtensions)
            .flatten()
            .map(_.toLower)
            .value();
    };


    //=======================//
    // Local File Validation //
    //=======================//

    var readFile = function (fileItem) {
        self.fileUploadProgress = 1;
        var deferred = $q.defer();
        var reader = new FileReader();
        reader.onload = function (event) {
            self.fileUploadProgress = 100;
            deferred.resolve(event);
        };
        reader.onprogress = function (event) {
            self.fileUploadProgress = Math.round((event.loaded * 100) / event.total);
        };
        reader.readAsDataURL(fileItem._file);
        return deferred.promise;
    };

    var createResult = function (fileItem, event, errors) {
        return {
            source: fileItem.file.name,
            errors: errors,
            warnings: [],
            uploadData: {
                path: fileItem.file.name,
                data: event.target.result
            }
        };
    };

    var imageAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            var deferredImage = $q.defer();
            var img = new Image();
            img.onload = function () {
                if (self.fileHeights.indexOf(img.height + '') === -1 ||
                    self.fileWidths.indexOf(img.width + '') === -1) {
                    deferredImage.resolve(createResult(fileItem, event, [{
                        description: 'File Dimensions not valid!',
                        severity: 'ERROR'
                    }]));
                } else {
                    self.previewImage = $window.URL.createObjectURL(fileItem._file);
                    deferredImage.resolve(createResult(fileItem, event, []));
                }
            };
            img.src = event.target.result;
            return deferredImage.promise;
        });
    };

    var audioAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            return createResult(fileItem, event, []);
        });
    };

    var baseFileAddHandler = function (fileItem) {
        return readFile(fileItem).then(function (event) {
            return createResult(fileItem, event, []);
        });
    };

    self.validateLocalFile = function (fileItem) {
        switch(self.resolve.fileFilterType.toLowerCase()) {
            case 'image':
            case 'other':
                return imageAddHandler(fileItem);
            case 'audio':
            case 'video':
                return audioAddHandler(fileItem);
            default:
                return baseFileAddHandler(fileItem);
        }
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    self.$onInit = function () {
        self.fileHeights = _.uniq(acceptHeights).join('|');
        self.fileWidths = _.uniq(acceptWidths).join('|');
        self.buttonTooltips = {
            LOCAL: self.getUploadButtonText()
        };
    };

    self.initializeLocalUploaderConfig = function (uploaderConfig) {
        var typeFilter = _.find(uploaderConfig.filters, {name: 'fileTypeFilter'});
        typeFilter.origFn = typeFilter.fn;
        // TODO: AB#88420 Once file-select checks fileTypes, remove this override
        typeFilter.fn = function (item, options) {
            let type = item.type.slice(item.type.lastIndexOf('/') + 1).toLowerCase();
            if (self.resolve.fileFilterType === 'VIDEO') {
                typeFilter.errorDescription = 'File Type not valid!';
                return type === 'quicktime';
            }
            return typeFilter.origFn(item, options);
        };
    };
}


angular.module('prism-ui.components').component('fileUploadModal', {
    templateUrl: 'components/modal/file-upload-modal/file-upload-modal-template.html',
    controller: FileUploadModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    }
});
